// extracted by mini-css-extract-plugin
module.exports = {"OnTelemetry":"ServiceCard_OnTelemetry__11MoE","OnRemote":"ServiceCard_OnRemote__Y6VPO","OnIvtouch":"ServiceCard_OnIvtouch__1-1B6"};